import { LISTAR_GRUPOS_RAMAIS, LISTAR_GRUPO_RAMAL_SELECIONADO, LISTAR_RAMAIS } from './mutation-types'

export default {
  [LISTAR_GRUPOS_RAMAIS]: (state, gruposRamais) => {
    state.gruposRamais = gruposRamais
  },
  [LISTAR_GRUPO_RAMAL_SELECIONADO]: (state, grupoRamal) => {
    state.grupoRamalSelecionado = grupoRamal
  },
  [LISTAR_RAMAIS]: (state, ramais) => {
    state.ramais = ramais
  },
}
